module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step step--7"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Let’s add more contacts for your loved one to call.")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("Optional")])]), _vm._v(" "), _c('div', {
    ref: "form",
    staticClass: "step__form"
  }, _vm._l((_vm.contacts), function(contact, index) {
    return _c('div', {
      key: index,
      staticClass: "step__form-block"
    }, [_c('InputField', {
      attrs: {
        "title": "NAME",
        "type": "text",
        "placeholder": "Name",
        "autocomplete": "",
        "disabled": false,
        "errored": false,
        "validated": _vm.nameValid(contact.name),
        "errorMessage": ""
      },
      model: {
        value: (contact.name),
        callback: function($$v) {
          _vm.$set(contact, "name", $$v)
        },
        expression: "contact.name"
      }
    }), _vm._v(" "), _c('InputField', {
      attrs: {
        "title": "MOBILE NUMBER",
        "type": "tel",
        "placeholder": "(123) 456-7890",
        "autocomplete": "mobile tel",
        "disabled": false,
        "errored": false,
        "validated": _vm.numberValid(contact.phone),
        "errorMessage": "",
        "mask": "(###) ###-####"
      },
      model: {
        value: (contact.phone),
        callback: function($$v) {
          _vm.$set(contact, "phone", $$v)
        },
        expression: "contact.phone"
      }
    })], 1)
  }), 0), _vm._v(" "), _c('a', {
    ref: "addButton",
    staticClass: "step__add",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addContactForm($event)
      }
    }
  }, [_c('span', {
    staticClass: "step__add-info"
  }, [_c('span', {
    staticClass: "step__add-icon"
  }, [_c('plusIcon')], 1), _vm._v(" "), _c('span', {
    staticClass: "step__add-name"
  }, [_vm._v("add another contact")])])]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Next")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56d78b05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/2-blocks/Step4_AddContacts.vue
// module id = 540
// module chunks = 1